var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__login"},[_c('router-link',{attrs:{"to":{name: 'auth:login'}}},[_vm._v(" Вход/Регистрация "),_c('img',{staticClass:"header__img",attrs:{"src":require("../../assets/img/IconUser.svg"),"alt":"Vector"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }